"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderItem = void 0;
const class_validator_1 = require("class-validator");
const errorTypes_1 = require("../../../../apis/spg/helpers/errorTypes");
const cloneModelObject_1 = require("../../../../apis/spg/util/cloneModelObject");
/**
 * The item and quantity that relates to the product the customer bought.
 * The item generally is a direct correlation to the cart item.
 * The only difference is that we store the information of the purchase in the backend.
 */
class SalesOrderItem {
    constructor() {
        this.quantity = 1;
    }
    get cost() {
        const isServiceItem = this.productId === "SERVICE";
        return isServiceItem ? this.totalPrice : this.price * this.quantity;
    }
    increment() {
        const clone = (0, cloneModelObject_1.cloneModelObject)(this);
        clone.quantity += 1;
        return clone;
    }
    decrement() {
        const clone = (0, cloneModelObject_1.cloneModelObject)(this);
        if (clone.quantity > 0) {
            clone.quantity -= 1;
        }
        return clone;
    }
    filterSensitiveData() {
        const clone = (0, cloneModelObject_1.cloneModelObject)(this);
        return clone;
    }
    serialize() {
        return {
            salesOrderId: this.salesOrderId,
            quantity: this.quantity,
            totalPrice: this.totalPrice,
            priceDiscounted: this.priceDiscounted ? this.priceDiscounted : 0,
            productId: this.productId
        };
    }
    async validate() {
        const validated = await (0, class_validator_1.validate)(this);
        if (validated.length > 0) {
            throw new errorTypes_1.ValidationError(validated);
        }
        return true;
    }
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)()
], SalesOrderItem.prototype, "salesOrderId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsNotEmpty)()
], SalesOrderItem.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsPositive)(),
    (0, class_validator_1.IsOptional)()
], SalesOrderItem.prototype, "totalPrice", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)()
], SalesOrderItem.prototype, "priceDiscounted", void 0);
exports.SalesOrderItem = SalesOrderItem;
//# sourceMappingURL=SalesOrderItem.js.map